module.exports = [
  "./objects/accessoriesShoeFlatPointy.svg",
  "./objects/accessoriesShoeFlatSimple.svg",
  "./objects/accessoriesShoeFlatSneaker.svg",
  "./objects/baggyPants.svg",
  "./objects/bodyHoodie.svg",
  "./objects/bodyJacket.svg",
  "./objects/bodyJacket2.svg",
  "./objects/bodyLabCoat.svg",
  "./objects/bodyLongSleeve.svg",
  "./objects/bodyPointingForward.svg",
  "./objects/bodyPointingUp.svg",
  "./objects/bodyPregnant.svg",
  "./objects/bodyTrenchCoat.svg",
  "./objects/bodyTurtleNeck.svg",
  "./objects/bottomSittingBaggyPants.svg",
  "./objects/bottomSittingSkinnyJeans1.svg",
  "./objects/bottomSittingSweatPants.svg",
  "./objects/bottomStandingBaggyPants.svg",
  "./objects/bottomStandingJogging.svg",
  "./objects/bottomStandingShorts.svg",
  "./objects/bottomStandingSkinnyJeans.svg",
  "./objects/bottomStandingSkinnyJeansWalk.svg",
  "./objects/bottomStandingSkirt.svg",
  "./objects/bottomStandingSprint.svg",
  "./objects/bottomStandingSweatpants.svg",
  "./objects/Home.svg",
  "./objects/headFrontAfro.svg",
  "./objects/headFrontAiry.svg",
  "./objects/headFrontCaesar.svg",
  "./objects/headFrontChongo.svg",
  "./objects/headFrontCurly.svg",
  "./objects/headFrontHijab2.svg",
  "./objects/headFrontHijab1.svg",
  "./objects/headFrontLong.svg",
  "./objects/headFrontNoHair.svg",
  "./objects/headFrontPony.svg",
  "./objects/headFrontRad.svg",
  "./objects/headFrontShort1.svg",
  "./objects/headFrontShort2.svg",
  "./objects/headFrontShortBeard.svg",
  "./objects/headFrontTop.svg",
  "./objects/headFrontTurban2.svg",
  "./objects/headFrontTurban1.svg",
  "./objects/headFrontWavy.svg",
  "./objects/objectsSeatBall.svg",
  "./objects/objectsSeatCube.svg",
  "./objects/objectsSeatCube2.svg",
  "./objects/pinkBodyHoodie.svg",
  "./objects/Plants.svg",
  "./objects/sceneHomePlant.svg",
  "./objects/sceneHomeTable.svg",
  "./objects/sceneHomeBigLeafPlant.svg",
  "./objects/sceneHomeLamp.svg",
  "./objects/sceneHomeHangingLamp.svg",
  "./objects/sceneHomeClock.svg",
  "./objects/scenePlantTopLeaves.svg",
  "./objects/scenePlantMaceta.svg",
  "./objects/scenePlantPlantLeft.svg",
  "./objects/scenePlantPlantRight.svg",
  "./objects/skinnyJeansSitting.svg",
  "./objects/sweatPants.svg",
  "./objects/undrawModernLife.svg",
  "./objects/Wheelchair.svg",
  "./objects/Whiteboard.svg",
  "./objects/Wireframe.svg"
];
